'use client';

import type { ReactElement } from 'react';
import { CommandRows } from '../sections';
import type { CommandDef } from '../types';

export function ActionsPage({
  heading,
  actions,
  onRunCommand,
}: {
  heading: string;
  actions: CommandDef[];
  onRunCommand: (command: CommandDef) => void;
}): ReactElement {
  return (
    <CommandRows commands={actions} heading={heading} onRun={onRunCommand} />
  );
}
